export const moduleRoutes = {
  root: 'auth',
  childForms: {
    universalLogin: {
      data: { title: 'Auth / Login' },
      requireAuth: false,
      functions: [],
      route: 'login',
    },
    registerUser: {
      data: { title: 'Auth / Register' },
      requireAuth: false,
      functions: [],
      route: 'registerUser',
    },
    requestPasswordForm: {
      data: { title: 'Auth / Password' },
      requireAuth: false,
      route: 'requestPassword',
    },
    simpleRegister: {
      data: { title: 'Auth / Password' },
      requireAuth: false,
      functions: [],
      route: 'simpleRegister',
    },
    changePasswordForm: {
      data: { title: 'Auth / ChangePassword' },
      requireAuth: false,
      route: 'changePasswordForm',
    },
    noSession: {
      data: { title: 'Auth / Parameters' },
      requireAuth: false,
      functions: [],
      route: 'nosession',
    },
    unauthorized: {
      data: { title: 'Auth / Parameters' },
      requireAuth: false,
      functions: [],
      route: 'unauthorized',
    },
    notfound: {
      data: { title: 'Auth / Parameters' },
      requireAuth: false,
      functions: [],
      route: 'notfound',
    },
  },
  layout: 'auth',
  loadChildren: () => import('src/app/pages/auth/auth.module').then(m => m.AuthModule),
};
